const CSS_VARIABLE_NAME = '--scrollbar-width';

export function measureScrollbarWidth(): number {
  const probe = document.createElement('div');
  probe.style.cssText =
    'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll;visibility:hidden';
  document.body.appendChild(probe);
  const width = probe.offsetWidth - probe.clientWidth;
  probe.remove();
  return width;
}

export function applyScrollbarWidthVariable(): void {
  const width = measureScrollbarWidth();
  document.documentElement.style.setProperty(CSS_VARIABLE_NAME, `${width}px`);
}
